import React from 'react';
import { TextField, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { partial } from 'lodash';
import RubricBlock from '@dyl/blocks/RubricBlock';
import useChangeEvent from '@dyl/hooks/useChangeEvent';
import useTaskField from '@dyl/pages/Tasks/edit/useTaskField';
import withProps from '@dyl/utils/withProps';
import TaskItems from '@dyl/blocks/TaskItems';
import TaskRadioImagesBlock from '@dyl/blocks/TaskRadioImagesBlock';
import TaskRadioTextBlock from "@dyl/blocks/TaskRadioTextBlock";
import ImagePicker from "@dyl/components/ImagePicker";

export default withProps(TaskItems, { itemComponent: Item });

const useItemStyles = makeStyles(theme => ({
    stimulus: {
        maxWidth: theme.breakpoints.values.sm,
    },
}));

function Item({ index }) {
    const isExample = index === 0;
    const useField = partial(useTaskField, 'items', index);
    const [stimulusText] = useField('stimulus_text');

    const isImageType = stimulusText !== undefined && stimulusText !== null;

    return (
        <>
            <Typography variant='h6'>
                {isExample ? 'Example' : `Item ${index} - ${isImageType ? 'Image' : 'Text'}`}
            </Typography>

            {isExample && <RubricBlock />}
            {isImageType ? <ImageItem index={index} /> : <TextItem index={index} />}
        </>
    );
}

function ImageItem({ index }) {
    const classes = useItemStyles();
    const useField = partial(useTaskField, 'items', index);
    const [stimulus, setStimulus, stimulusError] = useField('stimulus_text');
    const onStimulusChange = useChangeEvent(setStimulus);
    return (
        <>
            <TextField
                className={classes.stimulus}
                label='Stimulus Text'
                value={stimulus}
                onChange={onStimulusChange}
                variant='filled'
                fullWidth
                helperText={stimulusError || ' '}
                error={!!stimulusError}
            />

            <TaskRadioImagesBlock path={['items', index, 'answers']} />
        </>
    )
}

function TextItem({ index }) {
    const classes = useItemStyles();
    const useField = partial(useTaskField, 'items', index);
    const [stimulus, setStimulus, stimulusError] = useField('stimulus_image');
    return (
        <>
            <ImagePicker
                className={classes.stimulus}
                label='Stimulus Image'
                value={stimulus}
                onChange={setStimulus}
                variant='filled'
                fullWidth
                helperText={stimulusError || ' '}
                error={!!stimulusError}
            />

            <TaskRadioTextBlock path={['items', index, 'answers']} fieldName={'key_text'} />
        </>
    )
}